export default {
  default: '',
};
